import styled from 'styled-components/macro';
import { StandardBottomMargin, StandardSideMargin } from '../../../shared-styles';
import {
  FlexJustifyBetween,
  FlexJustifyCenter,
  FlexAlignCenter,
} from '../../../shared-styles/flex';

const MainContainer = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.theme.spacing(30)};
`;

export const FilterContainer = styled.div`
  ${StandardSideMargin}
  ${StandardBottomMargin}
  height: 50px;
  background-color: ${(props) => props.theme.palette.blue[100]};
  margin-top: ${(props) => props.theme.spacing(30)};
`;

export const TrackingQueueContainer = styled.div`
  ${StandardSideMargin}
  height: calc(100vh - 110px);
  display: flex;
`;

export const InfoSection = styled.div`
  ${FlexJustifyBetween}
  padding: 0 2px;
`;

export const HeaderContainer = styled.div`
  ${FlexJustifyBetween}
  ${StandardSideMargin}
  margin-bottom: ${(props) => props.theme.spacing(30)};
  flex-wrap: wrap;
`;

export const SelectedOfficesContainer = styled.div`
  ${StandardSideMargin}
  margin-bottom: ${(props) => props.theme.spacing(10)};
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const LoadingContainer = styled.div`
  width: 100vw;
  ${FlexJustifyCenter};
`;

export const ErrorContainer = styled.div`
  ${FlexJustifyCenter}
  ${FlexAlignCenter}
  width: 100%;
  margin-top: 260px;
  font-size: ${(props) => props.theme.typography.sizes.h2};
`;

export default MainContainer;
